"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = ['is-one-fifth', 'is-one-quarter', 'is-one-third', 'is-two-fifths', 'is-half', 'is-three-fifths', 'is-two-thirds', 'is-three-quarters', 'is-four-fifths', 'is-full'];
exports.sizes = sizes;